import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { TextField } from '../reusable/TextField';
import { useLocation, useParams, useHistory } from "react-router-dom";
import validationSchema from "./validationSchema";
import ModalAlert from "../reusable/ModalAlert";
import { styles } from './styles';
import getAllUsers from "../IssueDetails/getAllUsers";
import getLabels from "../IssueDetails/getlabels";
import getProducts from "../IssueDetails/getProducts";
import getCrops from "../IssueDetails/getAllCrops";
import postAddIssue from "./postAddIssue";
import Select from "react-select";

const C = {
    dark: "#1a3328",
    mid: "#2d5a3d",
    bright: "#3d8c5e",
};

const getInitialValues = () => ({
    issueCode: null,
    farmerID: null,
    reporter: null,
    assignee: null,
    title: null,
    cropID: null,
    categoryID: null,
    problemID: null,
    productsRecommended: [],
    labels: [],
    description: null,
    status: "New",
    paid: false,
    issueType: 'Crop Related',
});

const AddIssue = (props) => {
    const history = useHistory();
    const location = useLocation();
    const { mobileNumber } = useParams();
    const [loadingInfo, setLoadingInfo] = useState(true);
    const [allUsers, setAllUsers] = useState([]);
    const [allLabels, setAllLabels] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [allCrops, setAllCrops] = useState([]);
    const [formValues, setFormValues] = useState(null);
    const [showAddIssueAlert, setShowAddIssueAlert] = useState(false);

    const loadAllUsers = async () => {
        const allUsersResponse = await getAllUsers();
        if (allUsersResponse.status == 200) {
            setAllUsers(allUsersResponse.data);
        }
    }

    const loadLabels = async () => {
        const allLabelsResponse = await getLabels();
        if (allLabelsResponse.status == 200) {
            setAllLabels(allLabelsResponse.data);
        }
    }

    const loadProducts = async () => {
        const allProductsResponse = await getProducts();
        if (allProductsResponse.status == 200) {
            setAllProducts(allProductsResponse.data);
        }
    }

    const loadCrops = async () => {
        const allCropsResponse = await getCrops();
        if (allCropsResponse.status == 200) {
            setAllCrops(allCropsResponse.data);
        }
    }

    useEffect(() => {
        const init = getInitialValues();
        const storedUser = JSON.parse(localStorage.getItem("user"));
        init.reporter = storedUser._id;
        init.assignee = storedUser._id;
        init.farmerID = props.farmerID || location.state?.farmerID;
        setFormValues(init);

        Promise.all([loadAllUsers(), loadLabels(), loadProducts(), loadCrops()]).then(() => {
            setLoadingInfo(false);
        });
    }, []);

    const handleAddIssue = async (values) => {
        if (values.farmerID && values.assignee && values.reporter && values.status && values.issueType) {
            if (values.issueType == "Other" || values.issueType == "Soil Related") {
                values.cropID = null;
                values.categoryID = null;
                values.problemID = null;
            } else {
                if (values.cropID == null) {
                    values.categoryID = null;
                    values.problemID = null;
                } else if (values.categoryID == null) {
                    values.problemID = null;
                }
            }
            const addIssueResponse = await postAddIssue(values);
            if (addIssueResponse.status == 200) {
                if (props.onSuccess) {
                    props.onSuccess(addIssueResponse.data.issue.issueCode);
                } else {
                    history.push(`/viewIssue/${addIssueResponse.data.issue.issueCode}`);
                }
            } else {
                setShowAddIssueAlert(true);
            }
        } else {
            setShowAddIssueAlert(true);
        }
    };

    if (loadingInfo || !formValues) return (
        <div style={{ padding: "2rem", textAlign: "center", color: "#5a6e61", fontSize: "0.9rem" }}>
            Loading…
        </div>
    );

    return (
        <>
            {/* Drawer header — shown only when used as an embedded panel */}
            {props.onCancel && (
                <div style={{ backgroundColor: C.dark, padding: "0.85rem 1.25rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 1 }}>
                    <span style={{ fontWeight: 700, fontSize: "0.85rem", letterSpacing: "0.06em", textTransform: "uppercase", color: "#fff" }}>
                        New Query
                    </span>
                    <button
                        onClick={props.onCancel}
                        style={{ background: "none", border: "none", color: "rgba(255,255,255,0.75)", cursor: "pointer", fontSize: "1.4rem", lineHeight: 1, padding: "0 4px" }}
                    >
                        ×
                    </button>
                </div>
            )}

            <div style={{ padding: "1.25rem 1.25rem 2rem" }}>
                <Formik
                    initialValues={formValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => handleAddIssue(values)}
                >
                    {(formikProps) => {
                        const { handleSubmit, handleBlur, values, touched, errors } = formikProps;
                        return (
                            <Form>
                                <Row>
                                    <Col md={6}>
                                        <label style={styles.label}>Query Raised By</label>
                                        <Field as="select" name="assignee" style={styles.select}>
                                            <option value="">Select User</option>
                                            {allUsers.map(val => (
                                                <option key={val._id} value={val._id}>{val.fullName}</option>
                                            ))}
                                        </Field>
                                    </Col>
                                    <Col md={6}>
                                        <label style={styles.label}>Query Type</label>
                                        <Field as="select" name="issueType" style={styles.select}>
                                            <option value="Crop Related">Crop Related</option>
                                            <option value="Soil Related">Soil Related</option>
                                            <option value="Fertilizer Management">Fertilizer Management</option>
                                            <option value="Other">Other</option>
                                        </Field>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <TextField label="Crop Query (Online)" name="title" type="text" />
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col>
                                        <label style={styles.label}>Symptom</label>
                                        <Select
                                            name="labels"
                                            placeholder="Select Symptoms"
                                            onChange={(selectedOption) => { values.labels = selectedOption; }}
                                            onBlur={handleBlur}
                                            options={allLabels}
                                            getOptionLabel={(opt) => opt.label}
                                            getOptionValue={(opt) => opt._id}
                                            isMulti={true}
                                            styles={{ container: (b) => ({ ...b, marginBottom: "1.25rem" }) }}
                                        />
                                    </Col>
                                </Row>

                                {values && (values.issueType === "Crop Related" || values.issueType === "Fertilizer Management") && (
                                    <Row className="mt-1">
                                        <Col md={4}>
                                            <label style={styles.label}>Crop</label>
                                            <Field as="select" name="cropID" style={styles.select} onClick={() => { values.categoryID = null; values.problemID = null; }}>
                                                <option value="">Select Crop</option>
                                                {allCrops.map(val => (
                                                    <option key={val._id} value={val._id}>{val.crop}</option>
                                                ))}
                                            </Field>
                                        </Col>
                                        {values.cropID && (
                                            <Col md={4}>
                                                <label style={styles.label}>Category</label>
                                                <Field as="select" name="categoryID" style={styles.select} onClick={() => { values.problemID = null; }}>
                                                    <option value="">Select Category</option>
                                                    {allCrops.filter(c => c._id == values.cropID)[0]?.categories.map(val => (
                                                        <option key={val._id} value={val._id}>{val.category}</option>
                                                    ))}
                                                </Field>
                                            </Col>
                                        )}
                                        {values.categoryID && values.cropID && (
                                            <Col md={4}>
                                                <label style={styles.label}>Problem Identified</label>
                                                <Field as="select" name="problemID" style={styles.select}>
                                                    <option value="">Select Problem</option>
                                                    {allCrops.filter(c => c._id == values.cropID)[0]?.categories.filter(cat => cat._id == values.categoryID)[0]?.problems.map(val => (
                                                        <option key={val._id} value={val._id}>{val.problemText}</option>
                                                    ))}
                                                </Field>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                <Row className="mt-1">
                                    <Col>
                                        <label style={styles.label}>Products Recommended</label>
                                        <Select
                                            name="productsRecommended"
                                            placeholder="Select Products Recommended"
                                            onChange={(selectedOption) => { values.productsRecommended = selectedOption; }}
                                            onBlur={handleBlur}
                                            options={allProducts}
                                            getOptionLabel={(opt) => opt.product}
                                            getOptionValue={(opt) => opt._id}
                                            isMulti={true}
                                            styles={{ container: (b) => ({ ...b, marginBottom: "1.25rem" }) }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-1">
                                    <Col>
                                        <label style={styles.label}>Query Description</label>
                                        <Field as="textarea" name="description" style={{ ...styles.textarea, height: "14rem" }} />
                                        {errors.description && touched.description && (
                                            <span style={styles.errorStyle}>{errors.description}</span>
                                        )}
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                        {props.onCancel && (
                                            <button
                                                type="button"
                                                onClick={props.onCancel}
                                                style={{ backgroundColor: "#fdecea", color: "#c62828", border: "1.5px solid #c62828", borderRadius: 7, padding: "0.42rem 1.1rem", fontSize: "0.85rem", fontWeight: 600, cursor: "pointer" }}
                                            >
                                                ✕ Cancel
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            onClick={() => handleSubmit()}
                                            style={{ backgroundColor: C.bright, color: "#fff", border: "none", borderRadius: 7, padding: "0.42rem 1.4rem", fontSize: "0.85rem", fontWeight: 700, cursor: "pointer" }}
                                        >
                                            ✓ Save Query
                                        </button>
                                    </Col>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </div>

            {showAddIssueAlert && (
                <ModalAlert
                    size="lg"
                    variant="danger"
                    message="Some Error Occurred"
                    resetCallback={setShowAddIssueAlert}
                />
            )}
        </>
    );
};

export default AddIssue;
